import gql from 'graphql-tag';

export default gql`
  fragment preleadProjectGroupCustomizeItemDateFragment on PreleadProjectGroupCustomizeItemDate {
    id
    value
    projectGroupPreleadCustomizeItemId
  }
`;
